import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';
import TertiaryMenuItem from '../model/TertiaryMenuItem';

// 墨子客製 Moztech 第一層 客製
const Moztech = new PrimaryMenuItem('Moztech', 'assessment');

// 第二層
const WarrantyList = new SecondaryMenuItem('WarrantyList', () => import('@/modules/moztech/views/WarrantyList.vue'));
const RPMoztechWarrantyRecordsMysql = new SecondaryMenuItem('RPMoztechWarrantyRecordsMysql', () => import('@/modules/report/views/RPView.vue'), { reporttype: 'RPMoztechWarrantyRecords' });
const warrantyMailEdit = new SecondaryMenuItem('WarrantyMailEdit');
const termsEdit = new SecondaryMenuItem('WarrantyTermsEdit', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'param', code: 'warrantyOfService' });

// 註冊第二層
Moztech.RegisterChild(WarrantyList);
Moztech.RegisterChild(RPMoztechWarrantyRecordsMysql);
Moztech.RegisterChild(warrantyMailEdit);
Moztech.RegisterChild(termsEdit);

// 第三層
const WaitingReceiveN = new TertiaryMenuItem('WaitingReceiveN', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_WaitingReceiveN_Moztech' });
const MaintenanceF = new TertiaryMenuItem('MaintenanceF', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_MaintenanceF_Moztech' });
const MaintenanceCompletedN = new TertiaryMenuItem('MaintenanceCompletedN', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_MaintenanceCompletedN_Moztech' });
const ConfirmN = new TertiaryMenuItem('ConfirmN', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_ConfirmN_Moztech' });
const MaintenanceN = new TertiaryMenuItem('MaintenanceN', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_MaintenanceN_Moztech' });
const MaintenanceCompletedF = new TertiaryMenuItem('MaintenanceCompletedF', () => import('@/modules/moztech/views/ContentSettingsEditor.vue'), { editType: 'email', code: 'Warranty_MaintenanceCompletedF_Moztech' });

// 註冊第三層
warrantyMailEdit.RegisterChild(WaitingReceiveN);
warrantyMailEdit.RegisterChild(MaintenanceN);
warrantyMailEdit.RegisterChild(MaintenanceCompletedN);
warrantyMailEdit.RegisterChild(ConfirmN);
warrantyMailEdit.RegisterChild(MaintenanceF);
warrantyMailEdit.RegisterChild(MaintenanceCompletedF);

export default Moztech;
